export const PRICE_ALERT_TYPES = {
  HIGHER_THAN: "1",
  LOWER_THAN: "2"
};
export const SCALED_ORDER_DISTRIBUTION_TYPES = {
  FLAT: "flat"
};
export const SCALED_ORDER_ACTION_TYPES = {
  BUY: "buy",
  SELL: "sell"
};